import { render, staticRenderFns } from "./autenticidade.vue?vue&type=template&id=70051432&scoped=true"
import script from "./autenticidade.vue?vue&type=script&lang=js"
export * from "./autenticidade.vue?vue&type=script&lang=js"
import style0 from "./autenticidade.vue?vue&type=style&index=0&id=70051432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70051432",
  null
  
)

export default component.exports